// extracted by mini-css-extract-plugin
export default {"skeleton":"components-hotel-benchmark-insight-charts-channel-chart-module__skeleton"};